/**
 * @Public Routes
 */
export const HomeRoute = "/"

/**
 * @Auth Routes
 */
export const DashboardRoute = "/"
export const AnalyzeRoute = "/analysis"
export const DataRoute = "/data"
export const UploadRoute = "/upload"